import { BaseService } from '@/infra/services/base-service';
import { Workstation } from '@/types/entities/Workstation';
import { GetWorkstationsMapper } from '@/core/mapper/workstation';
import { GetWorkstationsRequestDTO, GetWorkstationsResponseDTO } from '@/core/dto/workstation/get-workstations';
import type { SelectOption } from '@/components/ui/SelectOptions/types';

export class WorkstationService extends BaseService<Workstation> {
	private static instance: WorkstationService;

	private constructor(public readonly basePath: string = '/workstation/') {
		super();
	}

	public static getInstance(): WorkstationService {
		if (!WorkstationService.instance) {
			WorkstationService.instance = new WorkstationService();
		}
		return WorkstationService.instance;
	}

	public async getWorkstations(params: GetWorkstationsRequestDTO): Promise<SelectOption[]> {
		const url =
			this.basePath +
			`${params.line_id}?organization_id=${params.organization_id}&company_id=${params.company_id}`;
		const { data } = await this.getInstance().get<GetWorkstationsResponseDTO>(url);
		return new GetWorkstationsMapper(data).toDomain();
	}
}
